// NR decal cards: size-chip price, quick add.
// Quick add goes through Shopify's standard cart actions, which Horizon wires to its
// cart drawer. Without them the form still posts to /cart/add as normal HTML.

// Quick add, delegated on document: works for cards and for forms inside the cart drawer,
// which Horizon re-renders after every cart change.
document.addEventListener('change', (event) => {
  const input = event.target;
  const form = input instanceof HTMLInputElement ? input.closest('form[data-nr-quick-add]') : null;
  if (!form || input.name !== 'id' || !input.dataset.price) return;
  // Garage and try-on forms carry their price in the button; decal cards show it once, in the card body
  const card = form.closest('[data-nr-card]');
  const priceEl = form.querySelector('[data-nr-add-price]') || card?.querySelector('[data-nr-card-price]');
  if (priceEl) priceEl.textContent = input.dataset.price;
  // Tapping through to the product keeps the size picked on the card
  card?.querySelectorAll('a[href*="/products/"]').forEach((a) => {
    const url = new URL(a.href);
    url.searchParams.set('variant', input.value);
    a.href = url.href;
  });
  // A card's strikethrough is always the picked size's own compare-at price, or hidden
  const was = card?.querySelector('[data-nr-card-was]');
  if (was) {
    was.textContent = input.dataset.was || '';
    was.closest('s').hidden = !input.dataset.was;
  }
});

// A tap (or Enter) on Add paints its pressed state first; the form submits in the next task, so the submit listeners
// (ours and Shopify's own cart-add analytics, which take 50-250 ms on a slow phone) run outside the tap's frame
document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('button[type="submit"]') : null;
  const form = button?.form;
  if (!form?.matches('[data-nr-quick-add]') || !form.requestSubmit || !window.Shopify?.actions?.updateCart) return;
  if (event.defaultPrevented || button.getAttribute('aria-busy') === 'true') return;
  event.preventDefault();
  button.setAttribute('aria-busy', 'true');
  requestAnimationFrame(() =>
    setTimeout(() => {
      button.removeAttribute('aria-busy');
      if (form.isConnected) form.requestSubmit(button);
    })
  );
});

document.addEventListener('submit', async (event) => {
  const form = event.target instanceof HTMLFormElement && event.target.matches('[data-nr-quick-add]') ? event.target : null;
  if (!form) return;
  const actions = window.Shopify?.actions;
  if (!actions?.updateCart) return; // plain HTML post fallback
  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const labelEl = form.querySelector('[data-nr-add-label]');
  const idleLabel = labelEl?.dataset.idle ?? labelEl?.textContent;
  if (labelEl) labelEl.dataset.idle = idleLabel;
  const id = new FormData(form).get('id');
  if (!id || button?.getAttribute('aria-busy') === 'true') return;

  const drawer = form.closest('dialog');
  button?.setAttribute('aria-busy', 'true');
  try {
    const result = await actions.updateCart({ lines: [{ merchandiseId: String(id), quantity: 1 }] });
    if (result?.userErrors?.length) throw new Error(result.userErrors[0].message);
    button?.classList.add('is-added');
    if (labelEl) labelEl.textContent = 'Added';
    // Horizon may auto-open the drawer on cart change; don't slide it in twice, and never on /cart
    const inCart = form.closest('cart-items-component, dialog');
    if (!inCart && !document.querySelector('theme-drawer#cart-drawer[open], #cart-drawer dialog[open]')) actions.openCart?.();
    // The drawer re-renders after the add; keep keyboard focus inside it
    if (drawer) {
      setTimeout(() => {
        if (button?.isConnected) return;
        drawer.querySelector('.nr-gap__add, [name="checkout"], .cart__checkout-button, button')?.focus();
      }, 700);
    }
    setTimeout(() => {
      if (!button?.isConnected) return;
      button.classList.remove('is-added');
      if (labelEl) labelEl.textContent = idleLabel;
    }, 2200);
  } catch (error) {
    console.error(error);
    // No connection: say so on the button and stay on the page (a plain post would land on the browser's offline page)
    if (!navigator.onLine || error instanceof TypeError) {
      if (labelEl) {
        labelEl.textContent = 'Offline';
        setTimeout(() => {
          if (labelEl.isConnected) labelEl.textContent = idleLabel;
        }, 2500);
      }
      return;
    }
    form.submit(); // let Shopify's cart page report the problem
  } finally {
    button?.removeAttribute('aria-busy');
  }
});
